import React from "react";

export default function IconManageAgents() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 11.7651L9.74996 15.5825L6.74996 7.18421L15 10.2381L11.25 11.7651ZM11.25 11.7651L15 15.5825M5.39114 2.02197L5.97348 4.23436M3.85214 6.3938L1.6788 5.80099M10.4622 3.40522L8.87125 5.0248M4.62869 9.34361L3.0377 10.9632"
        stroke="#3F3F46"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
